import { createFileRoute } from "@tanstack/react-router"
import { EmployeeWorkHoursPage } from "@/features/companies/employee-work-hours-page"
export const Route = createFileRoute("/_authenticated/companies/$companyId/employees/$employeeId/work-hours")({
    component: RouteComponent,
})
function RouteComponent() {
    const { employeeId } = Route.useParams()
    return <EmployeeWorkHoursPage employeeId={employeeId} />
}
